module.exports = __webpack_public_path__ + "img/图层 12.5269d0ad.png";